import * as React from 'react';
import { matches } from '../../../util/TextUtil';
import * as environmentURL from './environmentURL';
import { EnvironmentContext } from './EnvironmentContext';
class EnvironmentProvider extends React.Component {
    static getDerivedStateFromProps(props, state) {
        const { app, tier, apiBaseURL = environmentURL.getPublicAPIBaseURL(tier), isParent } = props;
        const newState = { app, tier, apiBaseURL, childrenAreInsideParent: isParent };
        return state != null && matches(state, newState) ? null : newState;
    }
    constructor(props) {
        super(props);
        this.state = EnvironmentProvider.getDerivedStateFromProps(props, null);
    }
    render() {
        const providerProps = {
            children: this.props.children,
            value: { ...this.state }
        };
        const { children, isParent } = this.props;
        const isInsideParent = this.context.isInsideParent;
        if (!isParent && isInsideParent) {
            return children;
        }
        return React.createElement(EnvironmentContext.Provider, { ...providerProps });
    }
}
EnvironmentProvider.contextType = EnvironmentContext;
export default EnvironmentProvider;
